import React from 'react';
import { createRoot } from 'react-dom/client';
import LoginPage from './components/LoginPage';

document.addEventListener('DOMContentLoaded', () => {
  const container = document.getElementById('login-root');
  if (container) {
    const root = createRoot(container);
    const authUrl = container.dataset.authUrl;
    const alertMessage = container.dataset.alert;
    const noticeMessage = container.dataset.notice;

    root.render(
      <LoginPage
        authUrl={authUrl}
        alertMessage={alertMessage}
        noticeMessage={noticeMessage}
      />
    );
  }
});
